/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GagarinStaking,
  GagarinStakingInterface,
} from "../GagarinStaking";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "alpPerGgr",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "emergencyWithdrawFee",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "apr",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "CreatePool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "emergencyWithdrawFee",
        type: "uint256",
      },
    ],
    name: "EmergencyWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "oldPid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newPid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "ReStake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "WithdrawReward",
    type: "event",
  },
  {
    inputs: [],
    name: "GGR",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PERCENT_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ggr",
        type: "address",
      },
      {
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "__GagarinStaking_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "alpPerGgr",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "emergencyWithdrawFee",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "apr",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    name: "createPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
    ],
    name: "getPool",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "pid",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "staked",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paidReward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lockPeriod",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "alpPerGgr",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "emergencyWithdrawFee",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "apr",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool",
          },
        ],
        internalType: "struct GagarinStaking.PoolInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUser",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "pid",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakedAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalReward",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "stakedAt",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "lastRewardAt",
            type: "uint64",
          },
        ],
        internalType: "struct GagarinStaking.UserInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "moveStakingData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
    ],
    name: "reStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "releasable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ggr",
        type: "address",
      },
      {
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "setAddrs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPools",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GagarinStakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GagarinStakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GagarinStaking__factory extends ContractFactory {
  constructor(...args: GagarinStakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<GagarinStaking> {
    return super.deploy(overrides || {}) as Promise<GagarinStaking>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GagarinStaking {
    return super.attach(address) as GagarinStaking;
  }
  override connect(signer: Signer): GagarinStaking__factory {
    return super.connect(signer) as GagarinStaking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GagarinStakingInterface {
    return new utils.Interface(_abi) as GagarinStakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GagarinStaking {
    return new Contract(address, _abi, signerOrProvider) as GagarinStaking;
  }
}
